import { signInWithGoogle } from "../components/auth/google";
import { signInWithMicrosoft } from "../components/auth/microsoft";
import { signInWithApple } from "../components/auth/apple";
import AppleIcon from "@mui/icons-material/Apple";
import { ReactComponent as Google } from "../assets/icons/Google.svg";
import { ReactComponent as Microsoft } from "../assets/icons/Microsoft.svg";
import { Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../redux/store";
import { useEffect } from "react";
import useEnhancedNavigate, { injectTikTokScript, removeTikTokScript } from "./Session/helpers";

interface OauthProps {
  handleClose?;
  navigate?;
}

export const OauthButtons: React.FC<OauthProps> = ({ handleClose = () => { }, navigate }) => {
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    // Inject the script when the component mounts
    injectTikTokScript();
    return () => {
      // Remove the script when the component unmounts
      removeTikTokScript();
    };
  }, []);

  return (
    <div className="opacity-80 flex flex-col gap-2">
      <Button
        variant="outlined"
        onClick={() => signInWithGoogle(handleClose, dispatch, navigate)}
        startIcon={<Google className="!w-5 !h-5" />}
        className="!py-2 rounded-md border !border-primary-black-states-outlinedBorder hover:!bg-primary-black-states-hover !text-black dark:!text-white !text-transform-none"
      >
        Continue with Google
      </Button>
      <Button
        variant="outlined"
        onClick={() => signInWithMicrosoft(handleClose, dispatch, navigate)}
        startIcon={<Microsoft className="!w-5 !h-5" />}
        className="!py-2 rounded-md border !border-primary-black-states-outlinedBorder hover:!bg-primary-black-states-hover !text-black dark:!text-white !text-transform-none"
      >
        Continue with Microsoft
      </Button>
      <Button
        onClick={() => signInWithApple(handleClose, dispatch, navigate)}
        variant="outlined"
        startIcon={<AppleIcon className="!w-5 !h-5" />}
        className="!py-2 rounded-md border !border-primary-black-states-outlinedBorder hover:!bg-primary-black-states-hover !text-black dark:!text-white !text-transform-none"
      >
        Continue with Apple
      </Button>
    </div>
  );
};

const SocialBar: React.FC = () => {
  const navigate = useEnhancedNavigate();
  return (
    <div className="w-full md:w-[340px]">
      <div className="flex justify-start items-center">
        <div className="flex items-center justify-center">
        </div>
      </div>
      {/* Social media sign-in buttons */}
      <OauthButtons navigate={navigate} />
    </div>
  );
};

export default SocialBar;
